import React from 'react';

import PRODUCTS from './ProductDataTypes';
import {getSiteConfig} from '../config';

const SITE_CONFIG = getSiteConfig();

const generateResourceId = (id) => {
    return PRODUCTS.CORD_BLOOD_REGISTRY+"_"+id;
};


const data =
    {
        id: PRODUCTS.CORD_BLOOD_REGISTRY,
        alt:"Cord Blood Registry",
        title:(<React.Fragment>Cord Blood Registry<sup className="registerSymbol">®</sup> (CBR<sup className="registerSymbol">®</sup>)<br/>Newborn Stem Cell Preservation</React.Fragment>),
        productImages: [
            require('../assets/images/cord-blood-registry/CBR-product-img.png'),
            require('../assets/images/cord-blood-registry/CBR-product-img@2x.png'),
            require('../assets/images/cord-blood-registry/CBR-product-img@3x.png')
        ],
        description:null,
        videoData:{
            videoSets:[
                {
                    isChapterBased:true,
                    videos:[
                        {
                            resourceId:generateResourceId("vs1v1"),
                            title:null,
                            subTitle: (<>CBR<sup className="registerSymbolSmall">&reg;</sup> Collection Kit Instructions - How to perform a quality collection.</>),
                            description:(<>Make every collection count. The quality of the samples you collect may help increase the potential for use available to your patients and their families in the future. Learn from Dr. Karen Taylor, MD FACOG.</>),
                            descriptionBottom:null,
                            wistiaId:"6bopc42ejg",
                            wistiaConfig:{
                                padding:"56.25% 0 0 0"
                            }
                        }
                    ]
                }
            ]
        },
        documentData:{
            documents:[
                {
                    resourceId: generateResourceId("d1"),
                    title:"Quality Collection Handout",
                    description: "This handout lists steps for performing a quality collection and includes images of the collection kit components with descriptions.",
                    url:SITE_CONFIG.DOC_SITE_DEFAULT_URL+"/docs/cord-blood-registry/HCP_Quality_Collection_Handout_FINAL03282024.pdf",
                    thumbnails:[
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg1.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg1@2x.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg1@3x.png")
                    ]
                },

                {
                    resourceId: generateResourceId("d2"),
                    title:"Minimize Contamination Risk/Maximize Collection Volume Tip Sheet",
                    description: "This tip sheet provides steps on how to minimize contamination risk and maximize collection volumes.",
                    url:SITE_CONFIG.DOC_SITE_DEFAULT_URL+"/docs/cord-blood-registry/HCP_Min_Contam_Max_Volume_Handout_FINAL10082024.pdf",
                    thumbnails:[
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg2.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg2@2x.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg2@3x.png")
                    ]
                },

                {
                    resourceId: generateResourceId("d3"),
                    title:"Talking with Your Patients About Preserving Newborn Stem Cells",
                    description: "This guide provides talking points for healthcare providers to use to discuss newborn stem cell preservation with their patients such as:  What is cord blood & cord tissue preservation? Who is a match to a baby’s newborn’s stem cells? What are newborn stem cells used for? What are the current and potential uses of newborn stem cells and areas of research? How much does family banking cost?",
                    url:SITE_CONFIG.DOC_SITE_DEFAULT_URL+"/docs/cord-blood-registry/HCP_Talking_with_Your_Patients_Handout_FINAL.pdf",
                    thumbnails:[
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg3.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg3@2x.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg3@3x.png")
                    ]
                },

                {
                    resourceId: generateResourceId("d4"),
                    title:(<>Newborn Possibilities Program<sup>®</sup> Handout</>),
                    description: (<>This handout includes information about the CBR<sup>®</sup>  Newborn Possibilities Program, eligibility criteria and how to refer patients to the program.</>),
                    url:SITE_CONFIG.DOC_SITE_DEFAULT_URL+"/docs/cord-blood-registry/HCP_Newborn_Possibilities_Program_Handout_FINAL10082024.pdf",
                    thumbnails:[
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg4.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg4@2x.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg4@3x.png")
                    ]
                },

                {
                    resourceId: generateResourceId("d5"),
                    title:"Low Apgar Protocol",
                    description: (<>This pocket guide provides an overview of the Newborn Possibilities Program<sup>®</sup> and the Low Apgar Protocol as well as information on how to participate as a provider.</>),
                    url:SITE_CONFIG.DOC_SITE_DEFAULT_URL+"/docs/cord-blood-registry/HCP_Low_Apgar_Pocket_Guide_FINAL09062023.pdf",
                    thumbnails:[
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg5.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg5@2x.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg5@3x.png")
                    ]
                },

                {
                    resourceId: generateResourceId("d6"),
                    title:"Discover the Difference Handout",
                    description: (<>This handout provides information on why CBR<sup>®</sup> is the leader in newborn stem cell preservation and includes an overview of CBR’s state-of-the-art processing system technology.</>),
                    url:SITE_CONFIG.DOC_SITE_DEFAULT_URL+"/docs/cord-blood-registry/CBR_Competitive_Advantage_Handout_01032025.pdf",
                    thumbnails:[
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg6.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg6@2x.png"),
                        require("../assets/images/cord-blood-registry/doc-thumbs/document-thumbnail-CBRimg6@3x.png")
                    ]
                }
            ]
        },
        externalProductId:"D2-CBR"
    };


export default data;








